import icVoucher from 'static/ic-voucher.png';
import icCoin from 'static/ic-coin.png';
import icMoney from 'static/ic-money.png';
import icMagic from 'static/ic-magic.png';
import icLuckyCode from 'static/ic-lucky-code.png';
import prizeCoin from 'static/prize-coin.png';
import prizeMoney from 'static/prize-money.png';
import prizeMagic from 'static/prize-magic.png';
import prizeVoucher from 'static/prize-voucher.png';

export const MAX_POINT_PER_DAY = 30; // Fix lượt quay tối đa trong ngày

export const GAME_CODE_THEME_NEW = [
  "GAMETEST2026",
  "GAMEHDVMB32",
  "GAMEKHCNPILOT2026",
  "GAMEKHCNPILOTV22026",
];

export const NATIVE_ACTION = {
  ONG_VANG_WEB: 'ONG_VANG_WEB',
  INS_QUAYONG_VIEW: 'ins_quayong_view',
  INS_QUAYONG: 'ins_quayong',
  INS_QUAYONG_TRUNGTHUONG: 'ins_quayong_trungthuong',
  INS_QUAYONG_GHEPMANH_VIEW: 'ins_quayong_ghepmanh_view',
  INS_QUAYONG_GHEPMANH_SUCCESS: 'ins_quayong_ghepmanh_success',
};

export const MODAL_TYPE = {
  INFO: "INFO",
  RANK: "RANK",
  HISTORY: "HISTORY",
  WIN_PRIZE: "WIN_PRIZE",
  FUSION: "FUSION",
  COIN: "COIN",
  UN_EXPECTED: "UN_EXPECTED",
  UN_EXPECTED_NEW: "UN_EXPECTED_NEW"
}

export const PAGE = {
  ["MAGIC"]: MODAL_TYPE.FUSION,
}

export const DROP_TITLE = {
  [MODAL_TYPE.COIN]: "Xu ong",
  [MODAL_TYPE.FUSION]: "Mảnh ghép may mắn",
  [MODAL_TYPE.RANK]: "Bảng xếp hạng"
}

export const PRIZE_TYPE = {
  COIN: "COIN_MC",
  MONEY: "MONEY",
  VOUCHER: "VOUCHER",
  MAGIC: "MAGIC",
  LUCKY_CODE: "LUCKY_CODE"
}

export const PRIZE_CODE = {
  [PRIZE_TYPE.COIN]: 6,
  [PRIZE_TYPE.VOUCHER]: 7,
  [PRIZE_TYPE.MONEY]: 8,
  [PRIZE_TYPE.MAGIC]: 9,
  [PRIZE_TYPE.LUCKY_CODE]: 0,
}

export const PRIZE_TEXT = {
  [PRIZE_TYPE.COIN]: "xu ong",
  [PRIZE_TYPE.MONEY]: "giải ngày",
  [PRIZE_TYPE.VOUCHER]: "voucher",
  [PRIZE_TYPE.MAGIC]: "mảnh ghép",
  [PRIZE_TYPE.LUCKY_CODE]: "mã dự thưởng",
}



export const PRIZE_ICON = {
  [PRIZE_TYPE.COIN]: icCoin,
  [PRIZE_TYPE.MONEY]: icMoney,
  [PRIZE_TYPE.VOUCHER]: icVoucher,
  [PRIZE_TYPE.MAGIC]: icMagic,
  [PRIZE_TYPE.LUCKY_CODE]: icLuckyCode,
}

export const PRIZE_THUMB = {
  [PRIZE_TYPE.COIN]: prizeCoin,
  [PRIZE_TYPE.MONEY]: prizeMoney,
  [PRIZE_TYPE.VOUCHER]: prizeVoucher,
  [PRIZE_TYPE.MAGIC]: prizeMagic,
}

export const PRIZE_MESSAGE = {
  [PRIZE_TYPE.COIN]: "Bạn nhận được 68 Xu ong",
  [PRIZE_TYPE.MONEY]: "Chúc mừng bạn đã nhận được giải đặc biệt ngày. Giải thưởng sẽ được MB gửi đến bạn sau ít phút.",
  [PRIZE_TYPE.VOUCHER]: "Thông báo trúng thưởng voucher: Chúc mừng bạn nhận được voucher giảm 50k khi mua hàng tại Homefarm",
  [PRIZE_TYPE.MAGIC]: "Got it! Bạn đã thu thập thành công Mảnh ghép 1 tháng 6. Xem ngay kho mảnh của bạn để xem bộ sưu tập của mình nhé!",
}

export const LOSING_MESSAGE = [
  // "Giải thưởng còn nhiều. Chơi tiếp đi bạn",
  // "Chúc bạn may mắn lần sau",
  // "Giải thưởng siêu to khổng lồ, hãy kiên nhẫn"
  "Đừng buồn nhé! May mắn vẫn đang chờ bạn ở những lần quay tiếp theo đó!",
  "Tiếc quá! Nhưng đừng lo, cơ hội trúng thưởng vẫn còn rất nhiều đấy",
  "Tiếc quá! Nhưng đừng nản lòng nhé, vận may đang đến rất gần rồi đấy",
  "Tiếc quá! Hãy giữ tinh thần lạc quan và thử lại nào!",
  "Cảm ơn bạn đã tham gia! Cơ hội vẫn còn rất nhiều nên hãy tiếp tục tham gia nhé!",
  "Hãy giữ vững tinh thần và tiếp tục tham gia. Niềm vui đang chờ đón bạn!"
]

export const HISTORY_LIST = [
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep so 1 BINH THUONG",
    "serviceResCd": "",
    "createdDate": "28/06/2024 14:25:41",
    "magicType": "4",
    "magicMonth": "09/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  },
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep so 1 BINH THUONG",
    "serviceResCd": "",
    "createdDate": "21/06/2024 18:10:38",
    "magicType": "1",
    "magicMonth": "09/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  },
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep THANG 7 DONG VIEN",
    "serviceResCd": "",
    "createdDate": "06/06/2024 15:12:01",
    "magicType": "2",
    "magicMonth": "09/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  },
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep THANG 7 DONG VIEN",
    "serviceResCd": "",
    "createdDate": "06/06/2024 15:09:22",
    "magicType": "3",
    "magicMonth": "09/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  },
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep THANG 7 DONG VIEN",
    "serviceResCd": "",
    "createdDate": "06/06/2024 15:08:46",
    "magicType": "1",
    "magicMonth": "07/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  },
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep THANG 6 DONG VIEN",
    "serviceResCd": "",
    "createdDate": "06/06/2024 14:53:47",
    "magicType": "2",
    "magicMonth": "06/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  },
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep THANG 6 DONG VIEN",
    "serviceResCd": "",
    "createdDate": "06/06/2024 14:51:30",
    "magicType": "2",
    "magicMonth": "06/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  },
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep THANG 7 DONG VIEN",
    "serviceResCd": "",
    "createdDate": "06/06/2024 14:51:09",
    "magicType": "1",
    "magicMonth": "07/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  },
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep THANG 6 DONG VIEN",
    "serviceResCd": "",
    "createdDate": "06/06/2024 14:49:15",
    "magicType": "2",
    "magicMonth": "06/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  },
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep so 1 BINH THUONG",
    "serviceResCd": "",
    "createdDate": "06/06/2024 14:28:36",
    "magicType": "3",
    "magicMonth": "06/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  },
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep so 1 BINH THUONG",
    "serviceResCd": "",
    "createdDate": "06/06/2024 14:28:36",
    "magicType": "3",
    "magicMonth": "08/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  }
];

export const HISTORY_LIST_AFTER_FUSION = [
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep THANG 7 DONG VIEN",
    "serviceResCd": "",
    "createdDate": "06/06/2024 15:08:46",
    "magicType": "1",
    "magicMonth": "07/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  },
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep THANG 6 DONG VIEN",
    "serviceResCd": "",
    "createdDate": "06/06/2024 14:53:47",
    "magicType": "2",
    "magicMonth": "06/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  },
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep THANG 6 DONG VIEN",
    "serviceResCd": "",
    "createdDate": "06/06/2024 14:51:30",
    "magicType": "2",
    "magicMonth": "06/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  },
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep THANG 7 DONG VIEN",
    "serviceResCd": "",
    "createdDate": "06/06/2024 14:51:09",
    "magicType": "1",
    "magicMonth": "07/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  },
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep THANG 6 DONG VIEN",
    "serviceResCd": "",
    "createdDate": "06/06/2024 14:49:15",
    "magicType": "2",
    "magicMonth": "06/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  },
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep so 1 BINH THUONG",
    "serviceResCd": "",
    "createdDate": "06/06/2024 14:28:36",
    "magicType": "3",
    "magicMonth": "06/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  },
  {
    "giftGameCode": "TESTGAMEUPDATE01",
    "giftRewardType": "MAGIC",
    "giftRewardDescription": "Giai manh ghep so 1 BINH THUONG",
    "serviceResCd": "",
    "createdDate": "06/06/2024 14:28:36",
    "magicType": "3",
    "magicMonth": "08/2024",
    "magicPicture": "https://img.freepik.com/free-vector/illustration-jigsaw-icon_53876-5904.jpg?w=826&t=st=1719998177~exp=1719998777~hmac=5d481e7584b8b9f2b2dbcca9898d54c401a8caa5ce7d90d2868b1fc4afab2b08"
  }
];

export const GAMECODE_LIST = [
  {
    "gameCode": "1245",
    "gameName": "Chương trình 1256546 hương trình 1256546 hương trình 12565469999999999999999999999999999",
    "startDate": "2024-06-05 00:00:00 +0700 +07",
    "endDate": "2025-09-30 23:59:59 +0700 +07",
    "description": "Mô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tMô tả giải thưởngvvvvvvvvvvvvvvvvvvvv",
    "userGameStatus": "ACTIVE"
  },
  {
    "gameCode": "ONGVANG2024",
    "gameName": "Game Ong vàng",
    "startDate": "2024-06-05 00:00:00 +0700 +07",
    "endDate": "2024-07-31 23:59:59 +0700 +07",
    "description": "game ong 2024",
    "userGameStatus": "INACTIVE"
  },
  {
    "gameCode": "23432523525",
    "gameName": "Chương trình 123124124",
    "startDate": "2024-06-05 00:00:00 +0700 +07",
    "endDate": "2024-06-30 23:59:59 +0700 +07",
    "description": "5654656546",
    "userGameStatus": "INACTIVE"
  },
  {
    "gameCode": "GOH01",
    "gameName": "Chương trình game H01",
    "startDate": "2024-06-05 00:00:00 +0700 +07",
    "endDate": "2024-07-30 23:59:59 +0700 +07",
    "description": "Chương trình game test 01 không áp dụng giới hạn số lần trúng giải khách hàng và không áp dụng cơ chế giải động viên",
    "userGameStatus": "INACTIVE"
  },
  {
    "gameCode": "11",
    "gameName": "làm ơn đừng xoá",
    "startDate": "2024-06-05 00:00:00 +0700 +07",
    "endDate": "2024-06-19 23:59:59 +0700 +07",
    "description": "213",
    "userGameStatus": "INACTIVE"
  },
  {
    "gameCode": "TEST11",
    "gameName": "Chương trình test",
    "startDate": "2024-06-05 00:00:00 +0700 +07",
    "endDate": "2024-06-30 23:59:59 +0700 +07",
    "description": "34534354353455",
    "userGameStatus": "INACTIVE"
  },
  {
    "gameCode": "GAME04",
    "gameName": "CT GAME 04",
    "startDate": "2024-06-03 00:00:00 +0700 +07",
    "endDate": "2024-06-24 23:59:59 +0700 +07",
    "description": "5345534",
    "userGameStatus": "INACTIVE"
  },
  {
    "gameCode": "ONG",
    "gameName": "Game ong-thả game\\",
    "startDate": "2024-06-03 00:00:00 +0700 +07",
    "endDate": "2024-07-31 23:59:59 +0700 +07",
    "description": "34442",
    "userGameStatus": "INACTIVE"
  },
  {
    "gameCode": "DFDFDF",
    "gameName": "fdf",
    "startDate": "2024-06-03 00:00:00 +0700 +07",
    "endDate": "2024-06-30 23:59:59 +0700 +07",
    "description": "Mô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tả giải thưởngMô tMô tả giải thưởngvvvvvvvvvvvvvvvvvvvv",
    "userGameStatus": "INACTIVE"
  },
  {
    "gameCode": "GO03061",
    "gameName": "Chương trình game 03061",
    "startDate": "2024-06-03 00:00:00 +0700 +07",
    "endDate": "2024-06-19 23:59:59 +0700 +07",
    "description": "Chương trình không áp dụng số lần trúng giải",
    "userGameStatus": "INACTIVE"
  },
  {
    "gameCode": "18",
    "gameName": "Test 18",
    "startDate": "2024-06-03 00:00:00 +0700 +07",
    "endDate": "2024-06-30 23:59:59 +0700 +07",
    "description": "-\\",
    "userGameStatus": "INACTIVE"
  },
  {
    "gameCode": "ONVANG11",
    "gameName": "Chương trình Ong vàng 11",
    "startDate": "2024-05-30 00:00:00 +0700 +07",
    "endDate": "2024-06-30 23:59:59 +0700 +07",
    "description": "Mô tả232323",
    "userGameStatus": "INACTIVE"
  },
  {
    "gameCode": "ONGVANG10",
    "gameName": "Chương trinh Ong Vàng 10",
    "startDate": "2024-05-29 00:00:00 +0700 +07",
    "endDate": "2024-06-30 23:59:59 +0700 +07",
    "description": "Mô tả",
    "userGameStatus": "INACTIVE"
  },
  {
    "gameCode": "ONG29051",
    "gameName": "Chương trình 29051",
    "startDate": "2024-05-29 00:00:00 +0700 +07",
    "endDate": "2024-06-30 23:59:59 +0700 +07",
    "description": "Mô tả chương trìnhMô tả chương trìnhMô tả chương trìnhMô tả chương trìnhMô tả chương trìnhMô tả chương trìnhMô tả chương trìnhMô tả chương trìnhMô tả chương trìnhMô tả chương trìnhMô tả chương trìnhMô tả chương trìnhMô tả chương trìnhMô tả chương trìnhMô tả chương trình",
    "userGameStatus": "INACTIVE"
  },
  {
    "gameCode": "TESTGAMEUPDATE01",
    "gameName": "TEST GAME ONG CAI TIEN",
    "startDate": "2024-04-24 00:00:00 +0700 +07",
    "endDate": "2024-10-24 00:00:00 +0700 +07",
    "description": "TEST GAME ONG CAI TIEN",
    "userGameStatus": "INACTIVE"
  },
  {
    "gameCode": "HISKY01",
    "gameName": "Game Be the SKY",
    "startDate": "2024-04-02 15:30:00 +0700 +07",
    "endDate": "2024-10-31 23:59:59 +0700 +07",
    "description": "Game Be the SKY",
    "userGameStatus": "INACTIVE"
  }
];

export const DIAL_RESPONSE = {
  refNo: "9b36be26-f1dd-436f-9b6d-2dd4cfc8eb1f-202451014538752563",
  result: {
    ok: true,
    message: "OK",
    responseCode: "00"
  },
  dialData: {
    voucherCode: "",
    currentPoint: 917,
    dialResultNo: "1",
    dialResultNm: "Win reward embee",
    dialNo: "628123",
    dialedNumber: 6,
    dialRewardName: "Giai thuong manh ghep thang 6",
    dialRewardValue: "1000000",
    dialRewardType: "MONEY",
    dialRewardDescription: "Giai manh ghep so 1 BINH THUONG"
  }
}

export const RANK_TEMPLATE = {
  "result": {
    "ok": true,
    "message": "OK",
    "responseCode": "00"
  },
  "isInTopRank": true,
  "rankingList": [
    {
      "rankingOrder": 1,
      "customerName": "NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA",
      "totalRewardMoney": 159005000,
      "totalRewardCoin": 800
    },
    {
      "rankingOrder": 2,
      "customerName": "AUTOMATION TEST TRD",
      "totalRewardMoney": 60000,
      "totalRewardCoin": 500
    },
    {
      "rankingOrder": 3,
      "customerName": "USER NAME TEST",
      "totalRewardMoney": 159005000,
      "totalRewardCoin": 800
    },
    {
      "rankingOrder": 4,
      "customerName": "AUTOMATION TEST TRD",
      "totalRewardMoney": 60000,
      "totalRewardCoin": 500
    },
    {
      "rankingOrder": 5,
      "customerName": "USER NAME TEST",
      "totalRewardMoney": 159005000,
      "totalRewardCoin": 800
    },
  ],
  "userRanking": {
    "rankingOrder": 1000,
    "customerName": "NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA NGHĨA",
    "totalRewardMoney": 159005000,
    "totalRewardCoin": 800
  }
}
